import React, { useCallback, useState } from 'react'

import { Button } from '@material-ui/core'
import fileDownload from 'js-file-download'
import PropTypes from 'prop-types'

import { getCSV } from 'common/api'
import { formatter } from 'common/date'

const DailyBatchesDownloadManifestActionCell = ({ record }) => {
  const [isLoading, setIsLoading] = useState(false)
  const dateElem = formatter.format(record.SentDate)

  const saveFile = useCallback((fileBlob, sentDate) => {
    fileDownload(fileBlob, `scoir-student-list-${sentDate}`, 'text/csv')
  }, [])
  const download = useCallback(
    ({ scid, batchId, sentDate }) => {
      if (!isLoading) {
        setIsLoading(true)
        getCSV(`/api/colleges/${scid}/batches/${batchId}/indexfile`)
          .then((fileBlob) => saveFile(fileBlob, sentDate))
          .finally(() => setIsLoading(false))
      }
    },
    [isLoading, saveFile],
  )
  return (
    <Button
      onClick={() => download({ scid: record.Scid, batchId: record.Id, sentDate: record.SentDate })}
      disabled={isLoading}
      color="primary"
      variant={record.SystemState === 'delivered' ? 'outlined' : 'contained'}
      size="small"
      aria-label={`Download student list for ${dateElem}`}
    >
      Student List
    </Button>
  )
}

DailyBatchesDownloadManifestActionCell.propTypes = {
  record: PropTypes.object.isRequired,
}

export default DailyBatchesDownloadManifestActionCell
